import axios from '../axiosConfig';

const baseUrl = process.env.REACT_APP_NINJA_ADMIN_BASE_URL;

export const getVerticalsList = async (body) => {
    try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/analytics-report-query`;
        const data = await axios
        .post(url, body)
            .then((res) => res?.data?.data?.data);
        return data;
    } catch (error) {
        return error;
    }
}

export const getRefTypes = async (body) => {
    try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-ref-type-relations`;
        const data = await axios
        .post(url, body)
        .then((res) => res);
        return data;
    } catch (error) {
        return error;
    }
}

export const setRefValues = async (body) => {
    try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/position-code-metadata-relation`;
        const data = await axios
        .post(url, body)
        .then((res) => res);
        return data;
    } catch (error) {
        return error;
    }
}